export class LifeCircumstanceModel {
    name_de_CH = '';
    name_en_GB = '';
}